import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { ReviewTab } from "../../../../../companies/review/ReviewTab";

const companyRoute = getRouteApi(
  "/beratung/$taxAdvisoryId/unternehmen/$companyId"
);

export const Route = createFileRoute(
  "/beratung/$taxAdvisoryId/unternehmen/$companyId/review"
)({
  loader: async ({
    context: { queryClient, trpc },
    params: { taxAdvisoryId, companyId },
  }) => {
    void queryClient.ensureQueryData(
      trpc.taxAdvisorReviews.listTaxAdvisorReviews.queryOptions({
        taxAdvisoryId,
        companyId,
      })
    );
    void queryClient.ensureQueryData(
      trpc.annualStatements.listAnnualStatementsByCompanyId.queryOptions({
        taxAdvisoryId,
        companyId,
      })
    );
  },
  component: ReviewRoute,
});

function ReviewRoute() {
  const { taxAdvisoryId, companyId } = Route.useParams();
  const { jahr } = companyRoute.useSearch();

  return (
    <ReviewTab
      taxAdvisoryId={taxAdvisoryId}
      companyId={companyId}
      selectedYear={jahr ?? null}
    />
  );
}
